import { List, ListItem, styled } from "@mui/material";

export const Styled = {
    List: styled(List)`
        display: flex;
        align-items: center;
        flex-direction: row;
        border: 1px solid ${props => props.theme.palette.primary.main};
        border-radius: 6px;
    `,
    Item: styled(ListItem)`
        cursor: pointer;
        padding: 6px;
        transition: 0.25s linear background-color;
        &:hover {
            background-color: ${props => props.theme.palette.primary.main};
        }
    `,
};
